//Episerver library
import Start from "@episerver/spa-core";
//Application
import Config from "app/Config";
Start(Config);
